import {
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { Store } from '@ngxs/store';
import { AuthState } from '@app/store/auth/auth.state';
import { environment } from 'environments/environment';
import { catchError } from 'rxjs/operators';
import { StateResetAll } from 'ngxs-reset-plugin';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private _store: Store,
    private _router: Router,
    private _toastrService: ToastrService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = this._injectHeaderToken(req);

    return next.handle(req).pipe(catchError((err) => this._eventError(req, next, err)));
  }

  private _injectHeaderToken(req: any) {
    const urls = [
      environment.API_URL_COLLECT,
      environment.API_URL_COLLECT_VAREJO,
      environment.API_URL_CATALOG,
      environment.API_URL_RECERTIFICATION,
      environment.API_URL_RECERTIFICATION_VAREJO,
      environment.API_URL_MAINTENANCE_VAREJO,
      environment.API_URL_TVF_LOGS,
      environment.API_URL_DEALER,
      environment.API_URL_RECEIPT,
    ];

    if (urls.some(url => req.url.startsWith(url))) {
      const token = this._store.selectSnapshot<AuthState>((state: any) => state.auth.token);
      return req.clone({
        setHeaders: {
          authorization: `Bearer ${token}`,
        },
      });
    }

    return req;
  }

  private _eventError(req: HttpRequest<any>, next: HttpHandler, err: any) {
    const generalError = typeof err.error === 'string' ? new Error(err.error) : err.error;
    if (err instanceof HttpErrorResponse) {
      if (window['ineum']) {
        const error =
          Array.isArray(err?.error?.errors) && err.error.errors.length > 0
            ? err.error.errors[0]
            : 'no report error api.';

        window['ineum']('reportEvent', err.name, {
          timestamp: Date.now(),
          error: new Error(error),
          componentStack: err.message,
          meta: {
            errorApi: true,
            route: this._router.url,
            status: err.status,
          },
        });
      }

      if (err.status === 401) {
        this._store.dispatch(new StateResetAll());
        this._router.navigate(['login']);
        this._toastrService.warning('Sua sessão expirou. Realize a autenticação novamente!');
      }
    }

    return throwError(() => generalError);
  }
}
